module.exports = __webpack_public_path__ + "static/img/yk8100.ee9b72a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hardware/yk8100.png
// module id = g/rY
// module chunks = 1